<p-panel [header]="label" [toggleable]="true" [collapsed]="panelCollapsed">
  <div class="toolbar">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        [(ngModel)]="query"
        placeholder="Search by domain or description"
        class="w-full"
        aria-label="Search domains"
      />
    </span>

    <span class="count" *ngIf="domains?.length">
      {{ filteredDomains.length }} / {{ domains.length }}
    </span>
  </div>

  <div
    class="domain-list-scroll"
    [class.two-col]="filteredDomains.length >= twoColumnMin"
  >
    <div class="domain-row select-all-row" *ngIf="filteredDomains.length > 0">
      <p-checkbox
        [binary]="true"
        [ngModel]="isAllFilteredSelected"
        (onChange)="toggleSelectAll()"
        [inputId]="'select-all'"
      ></p-checkbox>
      <label class="domain-label" for="select-all">
        <span class="font-semibold">Select All ({{ filteredDomains.length }})</span>
        <span *ngIf="isSomeFilteredSelected" class="text-sm text-600 ml-2">
          ({{ getSelectedFilteredCount() }} selected)
        </span>
      </label>
    </div>
    <div
      *ngFor="let domain of filteredDomains; trackBy: trackByDomain"
      class="domain-row"
    >
      <p-checkbox
        [name]="domain.domain!"
        [value]="domain.domain"
        [(ngModel)]="selectedDomain"
        [inputId]="domain.domain"
      ></p-checkbox>

      <label class="domain-label" [for]="domain.domain">
        <span class="domain-id">{{ domain.domain }}</span>
        <span class="domain-desc" *ngIf="domain.description"
          >: {{ domain.description }}</span
        >
      </label>
    </div>

    <div *ngIf="!filteredDomains.length" class="empty-msg">
      No domains match your search.
    </div>
  </div>
</p-panel>

<div class="w-full text-center mt-3" *ngIf="domains?.length">
  <p-button
    icon="pi pi-refresh"
    [label]="requesting ? 'Processing ...' : buttonLabel"
    [disabled]="!selectedDomain || requesting"
    (onClick)="domainsSelected()"
  ></p-button>

  <p-button
    icon="pi pi-times"
    label="Clear"
    severity="secondary"
    class="ml-3"
    [disabled]="requesting"
    (onClick)="selectionCleared()"
  ></p-button>
</div>
